// extracted by mini-css-extract-plugin
module.exports = {"container":"Signup_container__3HuJn"};